/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

export const environment = {
  production: true,
  staging: false,
  development: false,
  apiHostname: 'https://prod-admin-api.nextpro.com',
  hostname: 'https://nextpro.com',
  hrTranscoderHostname: 'https://new-transcoder.nextpro.com',
  gameTranscoderHostname: 'https://game-uploads-transcoder.nextpro.com',
  recurlyApiKey: 'ewr1-4nQeaQ5ivaPJk3eqYZ50Kg',
  facebook: {
    appId: '2265218963504770',
    version: 'v3.0',
  },
  bitmovinPlayerKey: 'a998d64d-b8d1-443c-bd7b-b08de41f6a2f',
  bitmovinAnalyticsKey: '4aa6b208-7269-4961-8209-570e75f1ffbb',
  pusher: {
    key: 'a8598ae34e8c27bc20e2',
    cluster: 'us2',
    channel: 'nextpro-production',
  },
  chat: {
    instanceLocator: 'v1:us1:baa4414c-5b3b-472c-8b02-6b632752a750',
    tokenProvider:
      'https://us1.pusherplatform.io/services/chatkit_token_provider/v1/baa4414c-5b3b-472c-8b02-6b632752a750/token',
  },
  liveStreamHostname: 'https://dev-livestream.nextpro.com',
  liveStreamInstance1: 'https://dev-livestream-instance1.nextpro.com',
  liveStreamInstance2: 'https://dev-livestream-instance2.nextpro.com',
  intercomChatAppId: 'u6u2baai',
  mailchimpHostname: 'https://us18.api.mailchimp.com/3.0',
  mailchimpApiKey: '61ba635aee28fbb3857c3f09d6e9befa-us18',
  fastly: {
    static: 'https://nextpro-static.global.ssl.fastly.net',
    main: 'https://nextpro.global.ssl.fastly.net',
  },
  bucketName: 'nextpro',
  userUploadBucketName: 'nextpro-user-upload',
  webAssetsFolderName: 'web_assets',
  imports: [],
  transcoder: 'https://transcoder-1.nextpro.com',
  versionCheckInterval: 1000 * 60 * 30, // 30 minutes
};
